module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.ttf";